// extracted by extract-css-chunks-webpack-plugin
module.exports = {"box_title":"box_title-2bv6sKzC","bar":"bar-jNF6nG1j","title":"title-1n_3kedY"};